export const modalName = {
  CREATE_POST_MODAL: "createPostModal",
  EDIT_POST_MODAL: "editPostModal",
  VIEW_PROFILE_IMAGE_MODAL: "viewProfileImageModal",
  UPDATE_PROFILE_IMAGE_MODAL: "updateProfileImageModal",
  UPDATE_PROFILE_MODAL: "updateProfileModal",
  DEACTIVATE_ACCOUNT_MODAL: "deactivateAccountModal",
};
